<template>
  <section v-if="paymentDetails !== null" class="row policy-section-row" data-test-payment-section>
    <div class="columns policy-section-label small-12 medium-6 large-3">
      <h4 class="payment-info-label" data-test-policy-payment-label v-html="paymentDetails.label" />
    </div>
    <div class="columns small-12 medium-6 large-5">
      <!--markup desktop & tablet-->
      <div class="policy-section-view-list">
        <div
          v-for="(payment, i) in paymentDetails.payments"
          :key="'prev-payment-' + i"
          data-test-policy-payment-info
        >
          <div class="policy-payment-info-align">
            <div data-tag-date>
              <p
                v-if="payment.isLatePaymentFee"
                class="payment-info-date payment-info"
                data-test-policy-payment-late-fee-label
                v-html="paymentDetails.subPaymentLabel"
              />
              <p
                v-else
                class="payment-info-date payment-info"
                data-test-policy-payment-date
                v-html="payment.dateFormatted"
              />
            </div>
            <div v-if="payment.amountFormatted" data-tag-amount>
              <div class="payment-info">
                <span data-test-policy-payment-amount v-html="payment.amountFormatted" />
                <span
                  class="policy-payment-info-disclaimer"
                  data-test-payment-disclaimer
                  v-html="payment.disclaimer"
                />
              </div>
              <div
                v-if="payment.additionalStatusText"
                class="payment-info"
                data-test-payment-additional-status-text
                v-html="payment.additionalStatusText"
              />
              <div v-if="payment.subPayment" class="payment-info">
                <div>
                  <span
                    data-test-policy-sub-payment-amount
                    v-html="payment.subPayment.amountFormatted"
                  />
                  <span
                    class="policy-payment-info-disclaimer"
                    data-test-sub-payment-disclaimer
                    v-html="payment.subPayment.disclaimer"
                  />
                </div>
                <div
                  v-if="payment.subPayment.additionalStatusText"
                  data-test-sub-payment-additional-status-text
                  v-html="payment.subPayment.additionalStatusText"
                />
              </div>
              <div v-if="payment.hasGeneratedBill" data-test-bill-info class="payment-info">
                <a
                  data-test-payment-bill
                  :href="payment.generatedBill.billUrl"
                  v-html="payment.generatedBill.billText"
                />
              </div>
            </div>

            <div class="policy-price-text">
              <span
                v-if="payment.hasBeenPaid"
                class="payment-status icon-circle-check"
                data-test-payment-status-icon
              />
              <span
                data-test-payment-status
                :class="{ 'payment-status-text': payment.hasBeenPaid }"
                v-html="payment.statusText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    paymentDetails: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
